import getCsrfToken from '../csrf_token';
import getValue from '../ab_tests';

const testName = 'view_restriction_without_subscription_v2';

export default async function getViewRestrictionAssignment(required = false) {
  const value = getValue(testName);

  if (value) {
    return [value];
  }

  if (!required) {
    return [null];
  }

  const token = await getCsrfToken();

  const response = await fetch('/ab_tests/view_restriction', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': token,
    },
  });

  if (response.ok) {
    const body = await response.json();

    if (body.amplitude_name) {
      identifyUser(body.amplitude_name, body.value);
    }

    return [body.value];
  }

  throw new Error('failed to get an assignment');
}

function identifyUser(name, value) {
  if (typeof amplitude !== 'undefined') {
    const identity = new amplitude.Identify();
    identity.set(name, value);

    amplitude.getInstance().identify(identity);
  }
}
